import React from 'react';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../../../hooks';
import { Icon } from '../../../../../Icon';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingLogo = () => {
  const { minWidth } = useResponsive();

  if (minWidth.isMD) {
    return (
      <Icon
        name="IconSweetgreenFull"
        color={theme.colors.KALE}
        width={WORDMARK_LOGO_SIZE.width}
        height={WORDMARK_LOGO_SIZE.height}
      />
    );
  }

  return (
    <Icon
      name="IconSweetgreen"
      color={theme.colors.KALE}
      width={MARK_LOGO_SIZE.width}
      height={MARK_LOGO_SIZE.height}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const MARK_LOGO_SIZE = { width: 24, height: 24 };
const WORDMARK_LOGO_SIZE = { width: 126, height: 24 };
